import { render, staticRenderFns } from "./ZaloChat.vue?vue&type=template&id=55acec5a&scoped=true&"
import script from "./ZaloChat.vue?vue&type=script&lang=js&"
export * from "./ZaloChat.vue?vue&type=script&lang=js&"
import style0 from "./ZaloChat.vue?vue&type=style&index=0&id=55acec5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55acec5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
